/* ELUENA Luxury — theme behaviours (vanilla, no dependencies) */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------------- reveal */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------- mobile menu */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ------------------------------------------------------------ cart drawer */
  var drawer = null;

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  function renderDrawer(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var footer = drawer.querySelector('[data-drawer-footer]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<p class="empty-state">' + (drawer.dataset.emptyText || 'Your cart is empty.') + '</p>';
      if (footer) footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') + '" alt="" width="72" height="72">' : '<div></div>';
      return '<div class="cart-line">' + img +
        '<div><a class="title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title ? '<div class="variant">' + item.variant_title + '</div>' : '') +
        '<div class="variant">' + item.quantity + ' × ' + formatMoney(item.final_price) + '</div>' +
        '<button class="text-link" type="button" data-remove-key="' + item.key + '">' + (drawer.dataset.removeText || 'Remove') + '</button></div>' +
        '<div class="line-total">' + formatMoney(item.final_line_price) + '</div></div>';
    }).join('');

    if (footer) {
      footer.hidden = false;
      var total = footer.querySelector('[data-drawer-total]');
      if (total) total.textContent = formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: format
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function fetchCart() {
    return fetch(routes + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function changeLine(key, quantity) {
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function initCart() {
    drawer = document.querySelector('[data-cart-drawer]');

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-cart-open]');
      if (openBtn && drawer) {
        event.preventDefault();
        fetchCart().then(function (cart) { renderDrawer(cart); updateCartCount(cart); openDrawer(); });
        return;
      }
      if (event.target.closest('[data-drawer-close]') || event.target.closest('.cart-drawer__overlay')) {
        closeDrawer();
        return;
      }
      var remove = event.target.closest('[data-remove-key]');
      if (remove) {
        event.preventDefault();
        changeLine(remove.getAttribute('data-remove-key'), 0).then(function (cart) {
          renderDrawer(cart);
          updateCartCount(cart);
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    /* Async add-to-cart for product forms and quick-add buttons */
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[data-product-form]');
      if (!form || !drawer) return;
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-disabled', 'true');

      fetch(routes + 'cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          return fetchCart();
        })
        .then(function (cart) { renderDrawer(cart); updateCartCount(cart); openDrawer(); })
        .catch(function (error) {
          var err = form.querySelector('[data-form-error]');
          if (err) { err.textContent = error.message; err.hidden = false; }
        })
        .finally(function () { if (button) button.removeAttribute('aria-disabled'); });
    });
  }

  /* ------------------------------------------------------- product gallery */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.getAttribute('data-src');
          main.srcset = '';
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ------------------------------------------------------- variant picker */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form[data-product-form]');
      var dataEl = document.querySelector('#VariantData-' + picker.dataset.sectionId);
      if (!form || !dataEl) return;
      var variants = JSON.parse(dataEl.textContent);

      picker.addEventListener('change', function () {
        var selected = Array.prototype.map.call(picker.querySelectorAll('input:checked, select'), function (el) { return el.value; });
        var match = variants.find(function (variant) {
          return variant.options.every(function (option, index) { return option === selected[index]; });
        });

        var idInput = form.querySelector('[name="id"]');
        var priceEl = document.querySelector('[data-product-price-' + picker.dataset.sectionId + ']');
        var button = form.querySelector('[type="submit"]');

        if (!match) {
          if (button) { button.disabled = true; button.textContent = button.dataset.unavailable; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = formatMoney(match.price);
        if (button) {
          button.disabled = !match.available;
          button.textContent = match.available ? button.dataset.addLabel : button.dataset.soldOut;
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  function init() {
    initReveal();
    initMenu();
    initCart();
    initGallery();
    initVariants();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Re-init inside the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
